import { render } from "./WheelchairFareClassSelector.vue?vue&type=template&id=a59134f6&scoped=true&lang=pug"
import script from "./WheelchairFareClassSelector.vue?vue&type=script&lang=ts"
export * from "./WheelchairFareClassSelector.vue?vue&type=script&lang=ts"

import "./WheelchairFareClassSelector.vue?vue&type=style&index=0&id=a59134f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a59134f6"

export default script